import base from './base'

export default {
  ...base,
  name: {
    type: ['undefined', 'string']
  },
  family_name: {
    type: ['undefined', 'string']
  },
  username: {
    type: ['undefined', 'string']
  },
  summary: {
    type: ['undefined', 'string']
  },
  birth_date: {
    type: ['undefined', 'string']
  },
  email: {
    type: ['undefined', 'string']
  },
  mobile: {
    type: ['undefined', 'string']
  },
  last_login: {
    type: ['undefined', 'string']
  },
  profile_picture: {
    type: ['object'],
    default: () => {
      return {}
    }
  },
  avatar_id: {
    type: ['undefined', 'string']
  },
  province_id: {
    type: ['undefined', 'string']
  },
  total_followers_count: {
    type: ['undefined', 'number']
  },
  total_followings_count: {
    type: ['undefined', 'number']
  },
  score: {
    type: ['undefined', 'number']
  },
  premium_remaining_days: {
    type: ['undefined', 'number']
  },
  is_premium: {
    type: ['boolean'],
    default: () => false
  },
  plan_id: {
    type: ['array'],
    default: () => []
  },
  balance: {
    type: ['undefined', 'number']
  },
  premium_until: {
    type: ['undefined', 'string']
  },
  referral_code: {
    type: ['undefined', 'string']
  },

}
